export class Defer <T> {
	readonly promise: Promise<T>;
	readonly resolve: (value: (T | PromiseLike<T>)) => void;
	readonly reject: (reason?: any) => void;
	
	constructor() {
		let _resolve: (value: (T | PromiseLike<T>)) => void;
		let _reject: (reason?: any) => void;
		
		this.promise = new Promise<T>((resolve, reject) => {
			_resolve = resolve;
			_reject = reject;
		});
		
		this.resolve = _resolve!;
		this.reject = _reject!;
	}
}